export const formatCurrency = (val: number, maximumFractionDigits: number = 2, currencyDisplay: 'symbol' | 'code' | 'name' = 'symbol') => {
	const formatter = new Intl.NumberFormat('nl-BE', {
		style: 'currency',
		currency: 'EUR',
		currencyDisplay: currencyDisplay,
		maximumFractionDigits: maximumFractionDigits,
	});
	return formatter.format(val);
};
